import { Button } from 'antd';
import { observer } from 'mobx-react-lite';
import * as React from 'react';
import { useTranslation } from 'react-i18next';

import { Formula, Spacing, SpacingRow, SpacingUnit } from 'components/ui';
import { DictionarySettingsDefaultValue } from 'stores/models/fieldsSettings';

type FormulaRendererProps = {
  store: DictionarySettingsDefaultValue;
};

const FormulaRenderer: React.FC<FormulaRendererProps> = ({ store }) => {
  const { t } = useTranslation();

  const disableFormula = React.useCallback(() => {
    store.setEditingFormulaState(false);
  }, [store]);

  return (
    <Spacing spacing={SpacingUnit.unit6}>
      <Formula
        formulaModel={store.newFormulaModel}
        disabled={!store.editingFormula}
        hideOperations={!store.editingFormula}
      />
      {store.editingFormula && (
        <SpacingRow hSpacing={SpacingUnit.unit2}>
          <Button onClick={store.setDataDisplayMode} size="large">
            {t('common.cancel')}
          </Button>
          <Button type="primary" onClick={disableFormula} size="large">
            {t('common.save')}
          </Button>
        </SpacingRow>
      )}
    </Spacing>
  );
};

export default observer(FormulaRenderer);
